if (!customElements.get('cbj-upsells')) {
  customElements.define('cbj-upsells', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.context !== 'product') return;
      this.onCartUpdate = () => {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 150);
      };
      document.addEventListener('cart:updated', this.onCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdate);
      clearTimeout(this.refreshTimer);
      this.controller?.abort();
    }

    async refresh() {
      this.controller?.abort();
      this.controller = new AbortController();
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('cbj-upsells[data-context="product"]');
        if (updated && this.isConnected) this.innerHTML = updated.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('Product recommendations could not refresh.');
      }
    }
  });
}

if (!customElements.get('cbj-upsell-card')) {
  customElements.define('cbj-upsell-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.select = this.querySelector('select[name="id"]');
      this.select?.addEventListener('change', () => {
        const option = this.select.selectedOptions[0];
        if (!option?.value) return;
        this.querySelector('[data-upsell-price]').textContent = option.dataset.price;
        const offerPrice = this.querySelector('[data-upsell-offer]');
        if (offerPrice) offerPrice.textContent = option.dataset.offer;
        this.querySelector('[name="quantity"]').value = option.dataset.min || '1';
      });
      this.querySelector('form')?.addEventListener('submit', () => {
        this.dispatchEvent(new CustomEvent('cbj:upsell-submit', {
          bubbles: true,
          detail: { productId: this.dataset.productId, variantId: this.querySelector('[name="id"]').value, placement: this.dataset.context }
        }));
      });
    }
  });
}

